﻿import ContentPopup from './content-popup';
import Steps from './steps';

export default class PaymentProvider {
    constructor() {
        this.dom = {
            $: window.$,
            jQuery: window.$,
            $form: $('form'),
            $toggleDisabledInput: $('.toggle-disabled-input'),
            $confirmButtons: $('.content-popup-confirmation'),
            $body: $('body')
        };

        //if (this.dom.$body.find('form').length) {
        this.init();
        //}
    }

    init() {
        new ContentPopup();
        //new FormEvents();
        //this.initToggleInputFocus();
        new Steps();
        //this.getBMParameterValues();
        //this.OpenBMPage();
        this.InitializeBM();
    }

    InitializeBM() {

        var popupDelayId;
        var popupOnStage4 = false;
        var bmProcessing = false;
        var bankverificationWindowClosed = false;
        var popupDelayTime = 30000;
        var popupWindow;

        //Setup stage 4 mouse leave/timer popup
        if ($('.verify-popup').length > 0) {
            $('.verify-popup').on('click', '.content-popup-close', function () {
                $('.verify-popup').removeClass('visible');
                //popupOnStage4 = false;
                timerPopup();
            })
            $('.verify-popup').on('click', '#frmBankVerification input[type=submit]', function (event) {
                $('.verify-popup').removeClass('visible');
                $('.loading-sceen').show();
            });

            if ($('#popup-interval').length > 0 && $('#popup-interval').data('popup-interval').length != '') {
                popupDelayTime = parseInt($('#popup-interval').data('popup-interval'));
            }

            timerPopup();
            //display popup when mouse leaves window
            $("html").on('mouseleave', function (e) {
                if (!popupOnStage4) {
                    showPopup();
                }
            });
            //Reset the popup timer if user clicks or moves mouse
            $("html").on('mousemove', function (e) {
                timerPopup();
            });
            $("html").on('keypress', function (e) {
                timerPopup();
            });
            function timerPopup() {
                clearInterval(popupDelayId);
                if (!popupOnStage4) {
                    popupDelayId = setInterval(function () {
                        showPopup();
                    }, popupDelayTime);
                }
            }
            function showPopup() {
                if (!$('.verify-popup').is(':visible')) {
                    $('.verify-popup').addClass('visible');
                    popupOnStage4 = true;
                }
            }
        }

        //Handle SS/1PLN agree check box behaviour
        $('body').on('change', '.agree-1', function () {
            $('a.btn-large').eq(0).toggleClass('disabled', !$(this).is(':checked'));
        });

        //$('.agree-1,.agree-2').trigger('change');

        $("body").on("click", "#frmOnePLNVerification input[type=submit]", function (event) {
            $('.loading-sceen').show();
            OpenBMPage(1, "#frmOnePLNVerification");
        });

        $("body").on("click", "#bnkverificationForm input[type=submit]", function (event) {
            if ($('.agree-1').is(':checked') && $('.agree-2').is(':checked')) {
                $('.loading-sceen').show();
                OpenBMPage(2, "#bnkverificationForm");
            }
        });

        function getBMParameterValues(bmservicetype) {
            var data;
            $.ajax({
                type: 'POST',
                async: false,
                url: '/api/sitecore/PaymentGateway/GetBMVerificationRequest',
                data: { serviceType: bmservicetype },
                error: function () { },
                success: function (response) {
                    data = response;
                }
            });

            return data;
        }

        function OpenBMPage(bmservicetype, formname) {

            var data = getBMParameterValues(bmservicetype);
            var bmdata = JSON.parse(data);

            //if (data == null || data.BmParameters.ErrorCode != null) {
            //    window.location.href = "#";
            //    event.preventDefault();
            //    return;[t]
            //}

            $('' + formname + ' #hdnServiceID').val(bmdata.ServiceID);
            $('' + formname + ' #hdnOrderID').val(bmdata.OrderID);
            $('' + formname + ' #hdnAmount').val(bmdata.Amount);
            $('' + formname + ' #hdnDescription').val(bmdata.Description);
            if (bmdata.GatewayID == '') { $('' + formname + ' #hdnGatewayID').remove(); }
            else { $('' + formname + ' #hdnGatewayID').val(bmdata.GatewayID); }
            $('' + formname + ' #hdnCurrency').val(bmdata.Currency);
            $('' + formname + ' #hdnCustomerEmail').val(bmdata.CustomerEmail);
            $('' + formname + ' #hdnTitle').val(bmdata.Title);
            $('' + formname + ' #hdnValidityTime').val(bmdata.ValidityTime);
            $('' + formname + ' #hdnVerificationFName').val(bmdata.VerificationFName);
            $('' + formname + ' #hdnVerificationLName').val(bmdata.VerificationLName);
            $('' + formname + ' #hdnVerificationStreet').val(bmdata.VerificationStreet);
            $('' + formname + ' #hdnVerificationStreetHouseNo').val(bmdata.VerificationStreetHouseNo);
            $('' + formname + ' #hdnVerificationStreetStaircaseNo').val(bmdata.VerificationStreetStaircaseNo);
            $('' + formname + ' #hdnVerificationStreetPremiseNo').val(bmdata.VerificationStreetPremiseNo);
            $('' + formname + ' #hdnVerificationPostalCode').val(bmdata.VerificationPostalCode);
            $('' + formname + ' #hdnVerificationCity').val(bmdata.VerificationCity);
            $('' + formname + ' #hdnVerificationNRB').val(bmdata.VerificationNRB);
            $('' + formname + ' #hdnLinkValidityTime').val(bmdata.LinkValidityTime);
            $('' + formname + ' #hdnHash').val(bmdata.Hash);

            //$('' + formname + ' #hdnServiceID').val('101700');
            //$('' + formname + ' #hdnOrderID').val('3100851');
            //$('' + formname + ' #hdnAmount').val('1.00');
            //$('' + formname + ' #hdnDescription').val('wplata');
            //$('' + formname + ' #hdnGatewayID').val('106');
            //$('' + formname + ' #hdnCurrency').val('PLN');
            //$('' + formname + ' #hdnCustomerEmail').val('j38@mailinator.com');
            //$('' + formname + ' #hdnTitle').val('wplata');
            //$('' + formname + ' #hdnValidityTime').val(bmdata.ValidityTime);
            //$('' + formname + ' #hdnVerificationFName').val('John');
            //$('' + formname + ' #hdnVerificationLName').val('Lewis');
            //$('' + formname + ' #hdnVerificationStreet').val('street');
            //$('' + formname + ' #hdnVerificationStreetHouseNo').val('5');
            //$('' + formname + ' #hdnVerificationStreetStaircaseNo').val(bmdata.VerificationStreetStaircaseNo);
            //$('' + formname + ' #hdnVerificationStreetPremiseNo').val('2');
            //$('' + formname + ' #hdnVerificationPostalCode').val('10-005');
            //$('' + formname + ' #hdnVerificationCity').val('city');
            //$('' + formname + ' #hdnVerificationNRB').val('04124034510000000000000001');
            //$('' + formname + ' #hdnLinkValidityTime').val(bmdata.LinkValidityTime);
            //$('' + formname + ' #hdnHash').val('1abadbb5e92316a4090bbd4fe4b7b45cc7c978fddab3a5c34c04dda02436c8b0');

            bmProcessing = true;
            var scrWidth = screen.availWidth;
            var paramWidth = (scrWidth < 750 ? scrWidth : 750);
            var paramLeft = parseInt((scrWidth - paramWidth) / 2);
            var scrHeight = screen.availHeight;
            var paramHeight = (scrWidth < 500 ? scrWidth : 500);
            var paramTop = parseInt((scrHeight - paramHeight) / 2);
            popupOnStage4 = true;
            var bmWindow = window.open('', 'BMwindow', 'width=' + paramWidth + ',height=' + paramHeight + ',top=' + paramTop + ',left=' + paramLeft + ',scrollbars=yes');
            var timer = setInterval(function () {

                if (bmWindow.closed) {
                    bankverificationWindowClosed = true;
                    clearInterval(timer);
                    $('.loading-sceen').hide();
                    popupOnStage4 = false;
                    location.reload();
                }
            }, 1000);
            return true;
        }

        //BM HUB Functionality Start

        $("body").on("click", "#oneplnBMHub .btn", (e) => {
            $('.loading-sceen').show();
            var bankid = $('#hdnBankId').val();
            if (bankid != undefined && bankid.trim().toString().length != 0) {
                openPopup('BMwindow');
                getBMHubURL(1);
            }
            else {
                $('.loading-sceen').hide();
                $('.bankId-validation-popup-1PLN').show();//sitecore item
                console.log("bankid is either null or empty");
            }
        });

        $("body").on("click", "#screenscarppingBMHub .btn", (e) => {
            if ($('.agree-1').is(':checked')) {
                $('.loading-sceen').show(0, () => {
                    openPopup('BMwindow');

                    getBMHubURL(2);
                });
            }
        });

        function getBMHubURL(bmservicetype) {
            var data;
            var bankid = $('#hdnBankId').val();
            $.ajax({
                type: 'POST',
                async: true,
                url: '/api/sitecore/PaymentGateway/GetBMHubURL',
                data: { transactionType: bmservicetype, bankId: bankid },
                error: function () {
                    cLog('getBMHubURL(' + bmservicetype + ') error');
                    popupWindow.close();
                    $('.loading-sceen').hide();
                },
                success: function (response) {
                    setPopupURL(response.BMHubURL);
                }
            });

            return data;
        }

        function openPopup(popupName) {

            let scrWidth = screen.availWidth;
            if (scrWidth < 993) {
                popupWindow = window.open('', '_blank');
                popupWindow.focus();
            } else {
                let paramWidth = (scrWidth < 750 ? scrWidth : 750);
                let paramLeft = parseInt((scrWidth - paramWidth) / 2);
                let scrHeight = screen.availHeight;
                let paramHeight = (scrWidth < 500 ? scrWidth : 500);
                let paramTop = parseInt((scrHeight - paramHeight) / 2);

                popupWindow = window.open('', popupName, 'width=' + paramWidth + ',height=' + paramHeight + ',top=' + paramTop + ',left=' + paramLeft + ',scrollbars=yes');
                popupWindow.focus();
            }
            let loadingStyle = "<meta name=\"viewport\" content=\"width=device-width,initial-scale=1,maximum-scale=1\"><style>body{font-family:sans-serif;}.loading-modal{position:fixed;left:0;top:0;width:100%;height:100%;background-color:#FFF;opacity:0.5;}.loading-panel{position:fixed;text-align:center;max-width:340px;padding:10px;border-radius:10px;background:#fff;width:270px;height:auto;font-size:14px;top:90px;left:50%;transform:translate(-50%,0%);}.loader{border-radius:50%;width:150px;height:150px;overflow:hidden;margin:20px auto;font-size:10px;position:relative;text-indent:-9999em;border:1.1em solid #e0e0e0;border-left:1.1em solid #00ace9;transform:translateZ(0);animation:load8 1.1s infinite linear;}@keyframes load8{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}</style>";
            popupWindow.document.write(loadingStyle + $('<div class="loading-sceen">').append($('.loading-sceen').html()).html());

            return true;
        }

        function setPopupURL(popupURL) {
            bmProcessing = true;
            popupOnStage4 = true;

            popupWindow.location = popupURL;
            $('.verification').addClass('pauseRefresh');

            var timer2 = setInterval(() => {
                if (popupWindow.closed) {
                    $('.loading-sceen').hide();
                    bankverificationWindowClosed = true;
                    clearInterval(timer2);
                    popupOnStage4 = false;
                    //location.reload();
                    $('.verification').removeClass('pauseRefresh');
                }
            }, 1000);

            return true;
        }

        //BM Hub Functionality Ends
    }


    initToggleInputFocus() {
        let $selectors = this.dom.$form.find('input, textarea').not('[type=checkbox]');

        $selectors
            .on('focus blur', this.toggleInputFocus.bind(this))
            .each((_, element) => {
                this.toggleInputFocus(element);
            });
    }

    toggleInputFocus(e) {
        if (!e) return;
        let $input = $(e.currentTarget ? e.currentTarget : e);
        let $parent = $input.parent();
        let $desiredElem = $parent.hasClass('eac-input-wrap') ? $parent.parent() : $parent;

        /** Trigger validation on autocomplete **/
        if (e.type === 'blur' && $input.prop('type') === 'email') {
            setTimeout(() => $input.trigger('focusout.validate', 200));
        }
        if ($parent.parent().hasClass('disabled')) {
            return;
        }

        $desiredElem
            .toggleClass('filled', $input.val().length > 0)
            .toggleClass('focus', document.activeElement === $input[0]);

        setTimeout(() => {
            $desiredElem.next('.input-results')
                .toggleClass('hidden', document.activeElement !== $input[0]);
        }, 200);
    }

    getBMParameterValues() {
        let thisDom = this.dom;

        //thisDom.$body.on("click", "#frmOnePLNVerification input[type=submit]", function (event) {
        //    $('.loading-sceen').show();
        //    alert("Test");
        //    OpenBMPage(1, "#frmOnePLNVerification");            
        //});

        //thisDom.$body.on("click", "#bnkverificationForm input[type=submit]", function (event) {
        //    $('.loading-sceen').show();
        //    OpenBMPage(2, "#bnkverificationForm");
        //});
    }

    getBMParametersCallBack(response) {
        let thisDom = this.dom;

        alert(response);
    }

    OpenBMPage(bmservicetype, formname) {

        //$.ajax({
        //    type: 'POST',
        //    async: false,
        //    url: '/api/sitecore/PaymentGatewayAPI/GetBMVerificationRequest',
        //    data: { serviceType: bmservicetype },
        //    error: function () { showRSbutton(!response.success); },
        //    success: function (response) {
        //        alert(response);
        //    }
        //});

        //let bmParameters = getAjaxData("/msiapi/paymentgatewayapi", "POST", false, bmservicetype, this.getBMParametersCallBack);

        //alert(bmParameters);
        //var data = getBMParameterValues(bmservicetype);

        //if (data == null || data.BmParameters.ErrorCode != null) {
        //  window.location.href = "#";
        //  event.preventDefault();
        //  return;[t]
        //}
        //var bmdata = data.BmParameters;
        //$('' + formname + ' #hdnServiceID').val(bmdata.ServiceID);
        //$('' + formname + ' #hdnOrderID').val(bmdata.OrderID);
        //$('' + formname + ' #hdnAmount').val(bmdata.Amount);
        //$('' + formname + ' #hdnDescription').val(bmdata.Description);
        //$('' + formname + ' #hdnGatewayID').val(bmdata.GatewayID);
        //$('' + formname + ' #hdnCurrency').val(bmdata.Currency);
        //$('' + formname + ' #hdnCustomerEmail').val(bmdata.CustomerEmail);
        //$('' + formname + ' #hdnTitle').val(bmdata.Title);
        //$('' + formname + ' #hdnValidityTime').val(bmdata.ValidityTime);
        //$('' + formname + ' #hdnVerificationFName').val(bmdata.VerificationFName);
        //$('' + formname + ' #hdnVerificationLName').val(bmdata.VerificationLName);
        //$('' + formname + ' #hdnVerificationStreet').val(bmdata.VerificationStreet);
        //$('' + formname + ' #hdnVerificationStreetHouseNo').val(bmdata.VerificationStreetHouseNo);
        //$('' + formname + ' #hdnVerificationStreetStaircaseNo').val(bmdata.VerificationStreetStaircaseNo);
        //$('' + formname + ' #hdnVerificationStreetPremiseNo').val(bmdata.VerificationStreetPremiseNo);
        //$('' + formname + ' #hdnVerificationPostalCode').val(bmdata.VerificationPostalCode);
        //$('' + formname + ' #hdnVerificationCity').val(bmdata.VerificationCity);
        //$('' + formname + ' #hdnVerificationNRB').val(bmdata.VerificationNRB);
        //$('' + formname + ' #hdnLinkValidityTime').val(bmdata.LinkValidityTime);
        //$('' + formname + ' #hdnHash').val(bmdata.Hash);

        //bmProcessing = true;
        //var scrWidth = screen.availWidth;
        //var paramWidth = (scrWidth < 750 ? scrWidth : 750);
        //var paramLeft = parseInt((scrWidth - paramWidth) / 2);
        //var scrHeight = screen.availHeight;
        //var paramHeight = (scrWidth < 500 ? scrWidth : 500);
        //var paramTop = parseInt((scrHeight - paramHeight) / 2);
        //popupOnStage4 = true;
        //var bmWindow = window.open('', 'BMwindow', 'width=' + paramWidth + ',height=' + paramHeight + ',top=' + paramTop + ',left=' + paramLeft + ',scrollbars=yes');
        //var timer = setInterval(function () {

        //    if (bmWindow.closed) {
        //        bankverificationWindowClosed = true;
        //        clearInterval(timer);
        //        $('.loading-sceen').hide();
        //        popupOnStage4 = false;
        //        location.reload();
        //    }
        //}, 1000);
        return true;
    }
}
